import { combineRules } from 'fela';

export const errors = ({ theme: { colors } }) => ({
    position: 'absolute',
    fontSize: '0.75rem',
    left: '2.45rem',
    color: colors.red,
    bottom: '-1rem',
});

export const label = () => ({
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
});

export const input = {
    position: 'absolute',
    opacity: 0,
    height: 0,
    width: 0,
};

const radioBase = ({ theme: { colors } }) => ({
    width: '1.5rem',
    height: '1.5rem',
    willChange: 'background-color',
    border: `1px solid`,
    borderRadius: '50%',
    background: colors.form.bgGrey,
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) background-color 0.3s, cubic-bezier(0.4, 0.0, 0.2, 1) box-shadow 0.3s',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.75rem',
});

export const radio = combineRules(radioBase, ({ theme: { colors } }) => ({
    borderColor: colors.form.borderGrey,
    background: colors.form.bgGrey,
}));

export const radioChecked = ({ theme: { colors } }) => ({
    background: colors.cyan,
    width: '0.875rem',
    height: '0.875rem',
    borderRadius: '50%',
    boxShadow: `0px 0px 4px 0px ${colors.cyan}`,
});

export const checkIcon = ({ theme: { colors }, checked }) => ({
    fill: checked ? colors.black : colors.form.bgGrey,
    width: '1rem',
    willChange: 'fill',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) fill 0.3s',
});

export const labelMessage = () => ({
    fontSize: '1.125rem',
    display: 'inline-flex',
    flexDirection: 'column',

    tablet: {
        flexDirection: 'row',
    },
});
